import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  orders: null,
};

const orderSlices = createSlice({
  name: "order",
  initialState,
  reducers: {
    setOrders(state, action) {
      state.orders = action.payload;
    },
  },
});

export const { setOrders } = orderSlices.actions;
export default orderSlices.reducer;
